import PlaylistItem from '../../models/playlistItem/playlistItem';
import SoundCloudPlaylist from '../../models/soundcloud/soundCloudPlaylist';

/**
 * A SoundCloud playlist as the shared streaming-service list rows want it.
 *
 * StreamingServicePlaylistRowRenderer reads `id` off every playlist and
 * hands it to the row's context-menu and add-to-playlist callbacks as a
 * string. SoundCloud's `id` is a deprecated number and the URN is what the
 * API wants, so the list is fed this view of the playlist, with the URN in
 * the seat the renderer reads, rather than the API object itself.
 */
export interface SoundCloudPlaylistListItem {
  /** The URN. */
  id: string;
  title: string;
  artworkUrl?: string | null;
  permalinkUrl: string;
  trackCount: number;
  playlist: SoundCloudPlaylist;
}

export function toListItem(playlist: SoundCloudPlaylist): SoundCloudPlaylistListItem {
  return {
    id: playlist.urn,
    title: playlist.title,
    artworkUrl: playlist.artwork_url,
    permalinkUrl: playlist.permalink_url,
    trackCount: playlist.track_count,
    playlist,
  };
}

/**
 * What a dragged SoundCloud playlist leaves in `ctx.dndData` for the drop
 * handler in playlistRowCommon.ts.
 *
 * The drop handler has no SoundCloud context of its own - its signature is
 * shared by four callers and adding one would touch all of them - so the
 * function that fetches a playlist's tracks travels with the drag instead.
 * The page registers one under `soundCloudPlaylistDragHelperKey` while it is
 * mounted, which covers drags from the right-hand playlist list too (those
 * rows only write the id into the transfer, not into dndData).
 */
export interface SoundCloudPlaylistDragHelper {
  addPlaylistToPlaylist(
    addItems: (i: PlaylistItem[]) => void,
  ): (playlistUrn: string) => Promise<void>;
}

export const soundCloudPlaylistDragHelperKey = 'soundcloud:playlists:dragHelper';
